import React from "react";

function Download() {
  return (
    <section className="py-16 px-4 md:px-12 bg-white text-gray-900">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-orange-700 mb-3">
          ⬇️ Download RF FUN REBORN
        </h2>

        <p className="text-center text-gray-600 mb-10">
          Download the installer and follow the simple installation guide below.
          <br />
          <span className="text-sm">
            Download installer dan ikuti panduan instalasi di bawah.
          </span>
        </p>

        {/* Download Links */}
        <div className="space-y-4">

          <div className="bg-gray-100 rounded-lg shadow p-5 flex flex-col md:flex-row md:items-center md:justify-between">
            <div>
              <h3 className="font-semibold text-lg">📦 Game Installer</h3>
              <p className="text-sm text-gray-600">
                Includes game files and launcher.
                <br />
                Sudah termasuk game dan launcher.
              </p>
            </div>

            <a
              href="https://mdev.my.id/file/FunServerInstaller.zip"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 bg-orange-600 hover:bg-orange-700 text-white px-5 py-2 rounded"
            >
              Download
            </a>
          </div>

          <div className="bg-gray-100 rounded-lg shadow p-5 flex flex-col md:flex-row md:items-center md:justify-between">
            <div>
              <h3 className="font-semibold text-lg">🛠 Visual C++ All-in-One</h3>
              <p className="text-sm text-gray-600">
                Required before launching the game.
                <br />
                Wajib diinstall sebelum menjalankan game.
              </p>
            </div>

            <a
              href="https://www.mediafire.com/file/o42lj3lz399c6f1/Visual-C-Runtimes-All-in-One-Mar-2025.zip/file"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 bg-orange-600 hover:bg-orange-700 text-white px-5 py-2 rounded"
            >
              Download
            </a>
          </div>

        </div>

        {/* Installation Guide */}
        <div className="mt-12 bg-gray-50 rounded-lg p-6 shadow">
          <h3 className="text-xl font-semibold mb-4">
            🚀 Installation Guide / Panduan Instalasi
          </h3>

          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700">
            <li>
              Run <strong>FunServerInstaller.exe</strong>.
              <br />
              Jalankan <strong>FunServerInstaller.exe</strong>.
            </li>

            <li>
              Select your installation folder.
              <br />
              Pilih folder tujuan instalasi.
            </li>

            <li>
              Click <strong>Install Game</strong> and wait until the installation is complete.
              <br />
              Klik <strong>Install Game</strong> dan tunggu hingga proses selesai.
            </li>

            <li>
              Launch <strong>FunRebornLauncher.exe</strong> to start playing.
              <br />
              Jalankan <strong>FunRebornLauncher.exe</strong> untuk mulai bermain.
            </li>
          </ol>
        </div>

        {/* Fix Patch */}
        <div className="mt-8 bg-blue-50 rounded-lg p-6 shadow">
          <h3 className="text-xl font-semibold mb-4">
            🔧 Fix Patch Guide / Panduan Fix Patch
          </h3>

          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700">
            <li>
              Run <strong>FunServerInstaller.exe</strong>.
              <br />
              Jalankan <strong>FunServerInstaller.exe</strong>.
            </li>

            <li>
              Select your existing RF installation folder.
              <br />
              Pilih folder RF yang sudah terinstall.
            </li>

            <li>
              Click <strong>Fix Patch</strong> and wait until the process is complete.
              <br />
              Klik <strong>Fix Patch</strong> dan tunggu hingga selesai.
            </li>
          </ol>
        </div>

        {/* Important Notes */}
        <div className="mt-8 bg-yellow-100 border-l-4 border-yellow-500 rounded p-5">
          <h3 className="font-semibold text-yellow-800 mb-2">
            📌 Important Notes / Catatan
          </h3>

          <ul className="list-disc list-inside text-sm text-yellow-800 space-y-1">
            <li>Install Visual C++ before launching the game.</li>
            <li>Install Visual C++ sebelum menjalankan game.</li>
            <li>Run the launcher as Administrator if needed.</li>
            <li>Jalankan launcher sebagai Administrator jika diperlukan.</li>
            <li>Temporarily disable antivirus if installation files are blocked.</li>
            <li>Matikan sementara antivirus jika file instalasi terblokir.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Download;